import { render, staticRenderFns } from "./FactcheckForm.vue?vue&type=template&id=38b07647&scoped=true"
import script from "./FactcheckForm.vue?vue&type=script&lang=ts"
export * from "./FactcheckForm.vue?vue&type=script&lang=ts"
import style0 from "./FactcheckForm.vue?vue&type=style&index=0&id=38b07647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b07647",
  null
  
)

export default component.exports